









import Vue from 'vue';
import StormFooter from '@/components/StormFooter.vue';

export default Vue.extend({
  name: 'App',
  components: {
    StormFooter,
  },

  data: () => ({
    //
  }),
});
